module.exports = __webpack_public_path__ + "img/lv5.24263e56.png";